export default "__VITE_ASSET__BsJs8$gY__"